// @flow

class A {}

function fn(a: A) {
    function fn2(a: A) {

    }
}
